import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if (window.location.protocol !== 'https:') {
  window.location.replace(`https:${window.location.href.substring(window.location.protocol.length)}`);
} else {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => {
      console.error(err);
      if (!document) return;
      const appRoot = document.getElementsByTagName('app-root');
      if (!appRoot.length) return;
      appRoot[0].classList.add('failed');
    });
}
